angular.module('ikeweb.user').controller('CreditCardUpdateController', ['creditCardService', 'billingService', 'pubSubService', 'userTopics',
    function(creditCardService, billingService, pubSubService, userTopics) {

        var card;

        var setLoading = function(loading) {
            return this.setLoading(loading);
        }.bind(this);

        var fireDismissEvent = function() {
            return this.fireDismissEvent();
        }.bind(this);

        function setCard(value) {
            card = value;
        }

        function resetCard() {
            Object.keys(card).forEach(function(key) {
                card[key] = '';
            });
        }

        function updateComplete() {
            resetCard();
            setLoading(false);
            fireDismissEvent();
        }

        function updateCard() {
            this.setLoading(true);

            creditCardService
                .loadCard(card)
                .then(billingService.updateCreditCard)
                .then(function() {
                    pubSubService.publish(userTopics.CREDITCARD.UPDATED);
                })
                .then(updateComplete, updateComplete);
        }

        this.setCard = setCard;
        this.updateCard = updateCard;
        this.resetCard = resetCard;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/credit.card.update.controller.js
// module id = 489
// module chunks = 0